var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 79,
    viewBox: "0 0 77 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    fillRule: "nonzero",
    d: "M0 68c0 1.878 1.522 3.4 3.4 3.4h66.3c2.817 0 5.1-2.283 5.1-5.1V23.8H0V68z",
    transform: "translate(-142 -139) translate(142 139)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE6DD",
    d: "M5.1 33.044c0-.41.33-.744.744-.744h10.412c.41 0 .744.33.744.744v10.412c0 .41-.33.744-.744.744H5.844c-.41 0-.744-.33-.744-.744V33.044zM5.1 51.744c0-.41.33-.744.744-.744h10.412c.41 0 .744.33.744.744v10.412c0 .41-.33.744-.744.744H5.844c-.41 0-.744-.33-.744-.744V51.744zM23.8 33.044c0-.41.33-.744.744-.744h10.412c.41 0 .744.33.744.744v10.412c0 .41-.33.744-.744.744H24.544c-.41 0-.744-.33-.744-.744V33.044zM23.8 51.744c0-.41.33-.744.744-.744h10.412c.41 0 .744.33.744.744v10.412c0 .41-.33.744-.744.744H24.544c-.41 0-.744-.33-.744-.744V51.744z",
    transform: "translate(-142 -139) translate(142 139)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    fillRule: "nonzero",
    d: "M71.4 6.8h-68C1.522 6.8 0 8.322 0 10.2v13.6h74.8V10.2c0-1.878-1.522-3.4-3.4-3.4z",
    transform: "translate(-142 -139) translate(142 139)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M17.85 0c2.347 0 4.25 1.903 4.25 4.25V15.3c0 .939-.761 1.7-1.7 1.7h-5.1c-.939 0-1.7-.761-1.7-1.7V4.25C13.6 1.903 15.503 0 17.85 0zM55.25 0c2.347 0 4.25 1.903 4.25 4.25V15.3c0 .939-.761 1.7-1.7 1.7h-5.1c-.939 0-1.7-.761-1.7-1.7V4.25C51 1.903 52.903 0 55.25 0z",
    transform: "translate(-142 -139) translate(142 139)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3DA26",
    fillRule: "nonzero",
    d: "M42.5 61.2c0 9.389 7.611 17 17 17s17-7.611 17-17-7.611-17-17-17-17 7.611-17 17z",
    transform: "translate(-142 -139) translate(142 139)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.95L3.4 9.35 10.2 0.85",
    transform: "translate(-142 -139) translate(142 139) translate(54.4 56.1)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCreate);
export default __webpack_public_path__ + "static/media/event_create.cc190d1d7fc24592af5de4cc0059700d.svg";
export { ForwardRef as ReactComponent };